// src/pages/FulfillmentPage/hooks/useFulfillment.ts
import { useState, useEffect } from "react";
import {
  getFulfillmentById,
  getLatestFulfillmentLabel,
  getFulfillmentLabels,
  type FulfillmentLabel,
} from "../../../api/fulfillmentApi";
import { Fulfillment } from "../types";

export function useFulfillment(fulfillmentId: number) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [fulfillment, setFulfillment] = useState<Fulfillment | null>(null);
  const [latestLabel, setLatestLabel] = useState<FulfillmentLabel | null>(null);
  const [labelHistory, setLabelHistory] = useState<FulfillmentLabel[]>([]);

  const load = async () => {
    if (!fulfillmentId) {
      setError("Invalid fulfillment id.");
      setLoading(false);
      return;
    }
    
    setError(null);
    setLoading(true);
    
    try {
      const data = await getFulfillmentById(fulfillmentId);
      setFulfillment(data);

      const isShipping = String(data.type).toLowerCase() !== "local_delivery";
      if (isShipping) {
        const [lbl, history] = await Promise.all([
  getLatestFulfillmentLabel(fulfillmentId),
  getFulfillmentLabels(fulfillmentId),
]);

setLatestLabel(lbl);
setLabelHistory(history);
      } else {
        setLatestLabel(null);
setLabelHistory([]);
      }
    } catch (e: any) {
      console.error(e);
      setError(e?.response?.data?.error || "Failed to load fulfillment.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [fulfillmentId]);

  return {
    loading,
    error,
    fulfillment,
    latestLabel,
    labelHistory,
    reload: load,
    setError,
  };
}